import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
        font-size: 2em;
        font-weight: 600;
        margin: 3em auto 1.4em;
        text-align: center;
        padding: 0 2em;
    }

    .image {
        margin-bottom: 5.2em;
        max-width: 18em;
    }

    @media all and (max-width: ${vars.mobileM}) {
    }
`;